let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h3zMw")).then(() => parcelRequire('1I9qh'));